import { Box, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage, useIntl } from "react-intl";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Landing from "../../../components/Landing";
import Handler from "./Handler";

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/PrestationCategory").PrestationCategory[]>>} swrResponsePrestationCategories
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Place").Place[]>>} swrResponsePlaces
 *
 * @param {Props} props
 */
function PrestationsSearchPublic({
  swrResponsePrestationCategories,
  swrResponsePlaces,
}) {
  const intl = useIntl();

  return (
    <Box
      background={{
        lg: "linear-gradient(90deg, rgba(247,250,252,1) 0%, rgba(247,250,252,1) 50%, rgba(0,0,0,0) 50%, rgba(0,0,0,0) 100%)",
      }}>
      <Landing
        src={generateFrontPath({
          id: "internal-assets",
          parameters: { filePath: "landing-activities.png" },
          includeBasePath: true,
        })}>
        <Breadcrumbs
          renderOnMobile={true}
          items={[
            {
              title: intl.formatMessage({ defaultMessage: "Accueil" }),
              url: generateFrontPath({ id: "@home" }),
            },
            {
              title: intl.formatMessage({ defaultMessage: "Nos activités" }),
            },
          ]}
        />

        <Text fontSize="3rem" fontWeight={400} lineHeight="normal" mt="1rem">
          <FormattedMessage defaultMessage="Nos activités" />
        </Text>
      </Landing>

      <Handler
        swrResponsePrestationCategories={swrResponsePrestationCategories}
        swrResponsePlaces={swrResponsePlaces}
      />
    </Box>
  );
}

export default PrestationsSearchPublic;
